module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container page-content"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.images), function(source) {
    return _c('img', {
      directives: [{
        name: "img",
        rawName: "v-img",
        value: ({
          group: 'novidades',
          src: source.path
        }),
        expression: "{group: 'novidades', src: source.path}"
      }],
      key: source.id,
      staticClass: "image-viewer-click rounded",
      staticStyle: {
        "margin-right": "7px",
        "margin-bottom": "7px"
      },
      attrs: {
        "src": source.thumb_url
      }
    })
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n                Novidades\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n            No auditório do American Towers Hotel, em Salvador Bahia,\n            o Programa Parceiro Simonetti, reuniu empresários da região que foram selecionados.\n            Recebidos com um delicioso café, e tiveram a oportunidade de conhecer a história\n            e as características da empresa e do programa.\n            Ao fim da apresentação, os empresários participaram de um happy hour com música ao vivo,\n            bom bate papo e diversão. Confira as fotos em nossa galeria.\n            "), _c('small', [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v("Clique na imagem para ampliar.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67a18b0c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/src/pages/Novidades.vue
// module id = 874
// module chunks = 0